import React from 'react';
import { toolIconPaths } from './core/tools';

/**
 * One glyph per tool, shared by the trace, the tools menu, the tool chip and the tag under a
 * question (stroke paths from core/tools.ts, drawn in the current text colour).
 */
export default function ToolIcon(props: {
  tool: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  const { tool, size = 14, strokeWidth = 2, className } = props;
  return (
    <svg
      className={className}
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0 }}
    >
      {toolIconPaths(tool).map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
